import React, { Component } from 'react';
import { browserHistory } from '../helpers/components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import _get from 'lodash/get';
import { setSearchBookings } from '../actions/searchBookings';
import * as BookingActions from '../actions/booking';
import * as PopupActions from '../actions/popup';
import * as UserActions from '../actions/user';
import { getUsageFromContract, setDeepRouterQuery } from '../helpers';

import SearchBookingsHomepageForm from './forms/SearchBookingsHomepageForm';
import { gtmPush, safe } from '../utils/utils';
import BusinessTabs from './BusinessTabs';
import LoginCta from './forms/LoginCta';
import { useMatch } from 'react-router-dom';
import { book, validateAccount } from '../constants/routes';

export class Homepage extends Component {
  constructor(props) {
    super(props);
    this.setCallbacks();
  }

  setCallbacks() {
    this.searchBookings = (formData) => {
      browserHistory.push({ pathname: `/${book}`, query: setDeepRouterQuery(formData) });
    };
  }

  // A visitor bounced off a legacy Renault-Mobility-France creation link: that
  // service lives in the mobile app, so the country/app-store selector popup
  // carries the "install the app" message.
  handleRenaultFranceUser() {
    const { showRenaultFrancePopup } = this.props.user;

    if (showRenaultFrancePopup) {
      this.props.setFlagToOpenRenaultFrancePopup(false);
      this.props.popup_MobileAppSelector_SetVisibility(true);
    }
  }

  componentDidMount() {
    this.handleGtm();
    this.componentPropsUpdated();
  }

  componentDidUpdate(pp) {
    this.componentPropsUpdated(pp);
  }

  componentPropsUpdated(pp) {
    this.handleActivationToken();
    this.handleRenaultFranceUser();
    this.updateUsageTypesField(pp);
  }

  contractUpdated(pp) {
    const { contract: next } = safe(() => this.props.brand.branded) || {};
    const { contract: prev } = safe(() => pp.brand.branded) || {};

    return next !== prev || !pp;
  }

  updateUsageTypesField(pp) {
    if (this.contractUpdated(pp)) {
      const { contract } = safe(() => this.props.brand.branded);
      const usage = getUsageFromContract(contract);

      this.props.dispatch(setSearchBookings({ usageTypes: usage }));
    }
  }

  handleGtm() {
    gtmPush(
      {
        event: '_virtualPageview',
        pageName: 'mobility|homepage'
      },
      _get(this.props, 'user.data.id')
    );
  }

  handleActivationToken() {
    const { token } = this.props.routeParams;
    const { accountActivation, onValidateAccountPage } = this.props;

    if (onValidateAccountPage && token && !this.accountActivationDisplayed) {
      this.accountActivationDisplayed = true;
      accountActivation(token).then(() => {
        browserHistory.push({
          pathname: '/',
          query: { modal: 'account-activation-popup' }
        });
      });
    }
  }

  showMainContent() {
    const { branded } = this.props.brand || {};
    const contract = branded.contract || {};
    const isRV = safe(() => contract.interfaceConfig.replacementVehicleDisplay);
    const { companyIdError, data: authUser } = this.props.user || {};

    // A restricted brand gives an anonymous visitor exactly one thing to do:
    // log in. Registration continues post-Keycloak (flags / picker / invite).
    if (branded.restrictedAccess && !authUser) {
      return <LoginCta msgKey={branded.loginMsgKey} />;
    }

    if (!isRV) {
      return (
        <div>
          {!authUser && branded.showServicesTabs && <BusinessTabs />}
          <SearchBookingsHomepageForm
            contract={contract}
            user={authUser}
            onSubmit={this.searchBookings}
            classname="search-booking-homepage"
            i18n={this.props.i18n}
            requestError={companyIdError}
          />
        </div>
      );
    }
  }

  render() {
    const { branded } = this.props.brand || {};

    const tagLine =
      safe(() => branded.productTagLinei18n[this.props.i18n.locale]) ||
      safe(() => branded.productTagLine);

    const { companyIdFetching } = this.props.user || {};
    const contract = branded.contract || {};
    const isRV = safe(() => contract.interfaceConfig.replacementVehicleDisplay);

    return (
      <div className="homepage">
        {(this.props.booking.searchBookingsFetching || companyIdFetching) && (
          <div className="loading-booking-overlay">
            <img src={require('./../assets/images/loader.gif')} alt="" />
          </div>
        )}

        <div className="container brand">
          <h1>
            <FormattedMessage
              id="home.welcome"
              values={{ productName: branded.productName }}
            />
          </h1>
          {!isRV && <h2>{tagLine}</h2>}
        </div>
        <div className="container search-container">
          <div className="search-wrapper">{this.showMainContent()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BookingActions,
      ...PopupActions,
      ...UserActions,
      dispatch
    },
    dispatch
  );
}

Homepage = connect(mapStateToProps, mapDispatchToProps)(Homepage);

const HomepageRoute = (props) => {
  return <Homepage {...props} onValidateAccountPage={!useMatch(`/${validateAccount}`)} />;
};

export default HomepageRoute;
